import {Price as PriceType} from '@wove/api/gql-types'

const Price = ({ price }: { price: PriceType }) => {
  return <span>${price.amount.toLocaleString()}</span>
}

export default Price
